import styled from "@emotion/styled";
import MenuItem from "@mui/material/MenuItem";

const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    font-size: 14px;
  }
`;

export default StyledMenuItem;
